import routes from "./routes"
import sideBarItems from "./sideBarItems"

export default {
  sideBarItems,
  routes,
}
